// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Week");

function make(week, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      var match = +(Network.pullWizardConfig(/* () */0) !== /* None */0);
      if (match === 0) {
        ReasonReact.Router[/* push */0]("/wizard/1");
      }
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Woche " + week), React.createElement("button", {
                          className: "login-button",
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek"));
                            })
                        }, "Workouts"), React.createElement("button", {
                          className: "login-button",
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/foodday");
                            })
                        }, "Mahlzeiten")), ReasonReact.element(/* None */0, /* None */0, Link.make("/blank", "blank", someLink, /* array */[])));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/week.re
// module id = 102
// module chunks = 0